import { FormDefinition } from "../../Components/Form/Form";
import { basic_number_validator, basic_text_validator, boolean_selection_validator, business_number_validator, date_validator, email_validator, multiselect_validator, phone_validator, selection_validator, url_validator } from "../formFieldValidators";


export const profileFormPersonalInfoDefinition: FormDefinition = {
        firstName: {
          label: "First Name",
          inputType: "text",
          frLabel: "Prénom",
          placeholder: "Your first name",
          frPlaceholder: "Votre prénom",
          validator: basic_text_validator,
        },
        lastName: {
          label: "Last Name",
          frLabel: "Nom de famille",
          inputType: "text",
          placeholder: "Your last name",
          frPlaceholder: "Votre nom de famille",
          validator: basic_text_validator,
        },
        // [TODO] handle conditional checkboxes and other field feature
        pronouns: {
          label: "Your Pronouns",
          frLabel: "Vos pronoms",
          inputType: "customMultiSelectNarrow",
          validator: multiselect_validator,
          additionalData: {
            selectionData: [
              {
                text: "she/her",
                frText: "elle",
                value: "she"
              },
              {
                text: "he/him",
                frText: "il",
                value: "he"
              },
              {
                text: "they/them",
                frText: "eux",
                value: "they"
              },
              {
                text: "prefer not to say",
                frText: "préfère ne pas répondre",
                value: "notToSay"
              },
            ]
          }
        },
        title: {
          label: "Job Title",
          inputType: "text",
          frLabel: "Titre du poste",
          placeholder: "Job Title",
          frPlaceholder: "Titre du poste",
          validator: basic_text_validator,
        },
        phoneNumber: {
          label: "Phone Number",
          inputType: "text",
          placeholder: "Numbers only please",
          frPlaceholder: "Chiffres seulement, s'il vous plaît",
          frLabel: "Numéro de téléphone",
          validator: phone_validator,
        }
      }

    export const profileFormPointOfContactDefinition: FormDefinition = {
        firstName: {
          label: "First Name",
          frLabel: "Prénom",
          inputType: "text",
          validator: basic_text_validator,
        },
        lastName: {
          label: "Last Name",
          frLabel: "Nom de famille",
          inputType: "text",
          validator: basic_text_validator,
        },
        // [TODO] pronouns is waiting on conditional checkboxes feature
        title: {
          label: "Job Title",
          frLabel: "Titre du poste",
          inputType: "text",
          validator: basic_text_validator,
        },
        email: {
          label: "Email",
          frLabel: "Courriel",
          inputType: "text",
          validator: email_validator,
        },
        phoneNumber: {
          label: "Phone Number",
          frLabel: "Numéro de téléphone",
          inputType: "text",
          validator: phone_validator,
        },
      }

    export const profileFormCompanyInfoDefinition: FormDefinition = {
      legalName: {
        label: "Legal Name",
        frLabel: "Nom légal",
        inputType: "text",
        placeholder: "Company's legal name",
        frPlaceholder: "Nom légal de l'entreprise",
        validator: basic_text_validator,
      },
        operatingName: {
          label: "Operating Name",
          frLabel: "Nom opérationnel",
          inputType: "text",
          placeholder: "Company's operating name",
          frPlaceholder: "Nom opérationnel de l'entreprise",
          validator: basic_text_validator,
        },
        description: {
          label: "Company Description",
          frLabel: "Description de l'entreprise",
          inputType: "textarea",
          placeholder: "Write your text here...",
          frPlaceholder: "Écrivez votre texte ici...",
          validator: basic_text_validator,
        },
        industry: {
          label: "Industry",
          frLabel: "Industrie",
          inputType: "dropdownSelect",
          placeholder: "Placeholder",
          frPlaceholder: "Sélectionner une option",
          tooltip: {
            content: "Click on the field and select an option from the list.",
            position: "bottom-right"
          },
          frTooltip: {
            content: "Cliquer sur le champ et sélectionner une option de la liste.",
            position: "bottom-right"
          },
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "Agriculture",
                text: "Agriculture",
                frText: "Agriculture",
              },
              {
                value: "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences",
                text: "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences",
                frText: "Matériaux d'avant-garde et fabrication Exclut spécifiquement la sylviculture, l'agriculture, l'exploitation minière, les technologies propres et les sciences de la vie.",
              },
              {
                value: "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources",
                text: "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources",
                frText: "Tech. propres : technologies qui protègent et/ou augmentent l'utilisation efficace des ressources de la terre, de l'eau et de l'air",
              },
              {
                value: "Consumer Retail",
                text: "Consumer Retail",
                frText: "Consommation de détail",
              },
              {
                value: "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions",
                text: "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions",
                frText: "Médias numériques et télécommunications Applications numériques et technologies de l'information et de communication Exclut les soins de santé, l'agriculture, la sylviculture, l'exploitation minière, les services financiers, l'éducation, l'innovation sociale, la culture et loisirs, et les solutions liées à l'énergie.",
              },
              {
                value: "Education",
                text: "Education",
                frText: "Éducation",
              },
              {
                value: "Financial Services",
                text: "Financial Services",
                frText: "Services financiers",
              },
              {
                value: "Food & Beverage",
                text: "Food & Beverage",
                frText: "Restauration/production d'aliments et boissons",
              },
              {
                value: "Forestry",
                text: "Forestry",
                frText: "Foresterie",
              },
              {
                value: "Life Sciences & Health",
                text: "Life Sciences & Health",
                frText: "Sciences de la vie et de la santé",
              },
              {
              value: "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies",
              text: "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies",
              frText: "Exploitation minière, pétrole et gaz : Comprend les activités d'extraction qui ne relèveraient pas autrement des technologies propres",
              },
              {
                value: "Tourism & Culture: Includes entertainment and sports",
                text: "Tourism & Culture: Includes entertainment and sports",
                frText: "Culture et tourisme : comprend le divertissement et le sport",
              },
              {
                value: "Transportation",
                text: "Transportation",
                frText: "Transport",
              },
              {
                value: "Other",
                text: "Other",
                frText: "Autre",
              }
            ]
          }
        },
        tech: {
          label: "Technology",
          frLabel: "Technologie",
          inputType: "multiSelect",
          validator: multiselect_validator,
          additionalData: {
            selectionData: [
              { value: "Advanced Digital Infrastructure",
                text: "Advanced Digital Infrastructure",
                frText: "Infrastructures numériques avancées"
              },
              {
                value: "Advanced Energy Technology",
                text: "Advanced Energy Technology",
                frText: "Technologies énergétiques avancées",
              },
              {
                value: "Advanced Materials and Manufacturing",
                text: "Advanced Materials and Manufacturing",
                frText: "Matériaux et fabrication de pointe",
              },
              {
                value: "Advanced Sensing and Surveillance",
                text: "Advanced Sensing and Surveillance",
                frText: "Détection et surveillance avancées",
              },
              {
                value: "Advanced Weapons",
                text: "Advanced Weapons",
                frText: "Armes avancées",
              },
              {
                value: "Aerospace, Space and Satellite",
                text: "Aerospace, Space and Satellite",
                frText: "Aérospatiale, espace et satellites",
              },
              {
                value: "Artificial Intelligence and Big Data",
                text: "Artificial Intelligence and Big Data",
                frText: "Intelligence artificielle et mégadonnées",
              },
              {
                value: "Human-Machine Integration",
                text: "Human-Machine Integration",
                frText: "Intégration humain-machine",
              },
              {
                value: "Life Science",
                text: "Life Science",
                frText: "Sciences de la vie",
              },
              {
                value: "Quantum Science",
                text: "Quantum Science",
                frText: "Science quantique",
              },
              {
                value: "Robotics and Autonomous Systems",
                text: "Robotics and Autonomous Systems",
                frText: "Robotique et systèmes autonomes",
              },
              {
                value: "Securetech",
                text: "Securetech",
                frText: "Technologies de sécurité",
              },
              {
                value: "Other",
                text: "Other",
                frText: "Autre",
              },
            ]
          }
        },
        hasDualUseApplications: {
          label: `Have you confirmed that your technology has potential dual-use (i.e. both civilian and military) applications?<br><br>Please note that indicating "yes" to this question will prompt our team to further investigate and validate your response if you are successful in reaching the next stage of the application process.`,
          frLabel: `Avez-vous confirmé que votre technologie a des applications potentielles à double usage (c.-à-d. civiles et militaires)?<br><br>Veuillez noter qu'une réponse « oui » à cette question incitera notre équipe à examiner et valider votre réponse de manière plus approfondie si vous atteignez l'étape suivante du processus de candidature.`,
          inputType: "boolean",
          validator: boolean_selection_validator,
        },
        websiteURL: {
          label: `Website URL. Please enter "N/A" if your company does not have a Website.`,
          frLabel: `URL du site Web. Veuillez entrer « S.O. » si votre entreprise n'a pas de site Web.`,
          inputType: "text",
          placeholder: "https://",
          frPlaceholder: "https://",
          validator: url_validator,
        },
        numFullTimeEmployees: {
          frLabel: "Votre entreprise compte combien d'employés à temps plein dans le monde (y compris le Canada)?",
          label: "What is the number of full-time employees at your company globally (including Canada)?",
          inputType: "number",
          validator: basic_number_validator,
        },
        numFullTimeEmployeesCan: {
          frLabel: "Votre entreprise compte combien d'employés à temps plein au Canada?",
          label: "What is the number of full-time employees at your company in Canada?",
          inputType: "number",
          validator: basic_number_validator,
        },
        revenueOverTwelveMonths: {
          frLabel: "Indiquez le revenu total de votre entreprise (en CAD) au cours de votre dernier exercice financier.",
          label: "Indicate your company's total revenue (in $CAD) during your most recent fiscal year.",
          inputType: "number",
          placeholder: "$",
          frPlaceholder: "$",
          validator: basic_number_validator,
        },
        revFromTech: {
          frLabel: "Indiquez le revenu total de votre entreprise (en CAD) au cours de votre dernier exercice financier.",
          label: "Is your primary source of revenue (or intended source, if pre-revenue) derived from the technology being developed and not from services or consulting?",
          inputType: "boolean",
          validator: boolean_selection_validator,
        },
        techReadiness: {
          label: `What is the Technology Readiness Level of your most mature product?<br>(For more information about Technology Readiness Levels please see the <a href="_blank" href="https://ised-isde.canada.ca/site/innovation-canada/en/technology-readiness-levels">ISED website.</a>)`,
          frLabel: `Quel est le niveau de maturité technologique de votre produit le plus abouti?<br>(Pour plus d'information sur les niveaux de maturité technologique, veuillez consulter le <a href="_blank" href="https://ised-isde.canada.ca/site/innovation-canada/en/technology-readiness-levels">site Web d'ISDE.</a>)`,
          inputType: "dropdownSelect",
          validator: selection_validator,
          additionalData: {
            selectionData: [
              {
                value: "trl1",
                text: "TRL 1: Basic principles observed and reported",
                frText: "NMT 1 : Principes de base observés et signalés"
              },
              {
                value: "trl2",
                text: "TRL 2: Technology concept and/or application formulated",
                frText: "NMT 2 : Concept technologique et/ou application formulés"
              },
              {
                value: "trl3",
                text: "TRL 3: Analytical and experimental proof of concept",
                frText: "NMT 3 : Preuve de concept analytique et expérimentale"
              },
              {
                value: "trl4",
                text: "TRL 4: Component and/or validation in a laboratory environment",
                frText: "NMT 4 : Composant et/ou validation en environnement de laboratoire"
              },
              {
                value: "trl5",
                text: "TRL 5: Component and/or validation in a simulated environment",
                frText: "NMT 5 : Composant et/ou validation en environnement simulé"
              },
              {
                value: "trl6",
                text: "TRL 6: System/subsystem model or prototype demonstration in a simulated environment (i.e. prototype ready)",
                frText: "NMT 6 : Démonstration d'un modèle ou d'un prototype de système/sous-système en environnement simulé (c.-à-d. prototype prêt)"
              },
              {
                value: "trl7",
                text: "TRL 7: Prototype ready for demonstration in an appropriate operational environment (i.e. MVP ready)",
                frText: "NMT 7 : Prototype prêt pour une démonstration dans un environnement opérationnel approprié (c.-à-d. produit minimum viable prêt)"
              },
              {
                value: "trl8",
                text: "TRL 8: Actual technology completed and qualified through tests and demonstrations (i.e. pilots deployed)",
                frText: "NMT 8 : Technologie réelle achevée et qualifiée au moyen d'essais et de démonstrations (c.-à-d. projets pilotes déployés)"
              },
              {
                value: "trl9",
                text: "TRL 9: Actual technology proven through successful deployment in an operational setting",
                frText: "NMT 9 : Technologie réelle éprouvée par un déploiement réussi dans un cadre opérationnel"
              }
            ]
          }
        },
        patentsGranted: {
          label: "How many patents (including industrial designs) have been granted to your company",
          frLabel: "Combien de brevets (y compris les dessins industriels) ont été accordés à votre entreprise",
          inputType: "number",
          validator: basic_number_validator,
        },
        number: {
          label:  `Your Canada Revenue Agency 9-Digit Business Number<br><p className="bodySmaller">The business number (BN), assigned to all incorporated businesses by the Canada Revenue Agency, is a 9-digit number that is unique to a business or legal entity. (Note: the BN is followed by a two-letter program identifier and a 4-digit reference number, both of which are unnecessary for this application). This number is different from the 7-digit Corporation Number and should not contain a hyphen.  If a valid 9-digit BN is not provided, the application will be rejected as it is a requirement for participation in ElevateIP.  For more details on what a BN is, visit <a target='_blank' href='https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html'>this website)</a></p>`,
          frLabel:  `Le numéro d'entreprise (NE) est un numéro à 9 chiffres attribué à toutes les entreprises constituées en société par l'Agence du revenu du Canada. Détenir un numéro d'enregistrement est une condition pour participer à ÉleverlaPI. Pour plus d'informations sur les numéros d'entreprise, (<a target='_blank' href='https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html'> cliquez ici.</a>)",`,
          inputType: "text",
          placeholder: "123456789",
          frPlaceholder: "123456789",
          validator: business_number_validator
        },
        date: {
          label: "Registration Date",
          inputType: "date",
          frLabel: "Date de l'enregistrement",
          validator: date_validator,
        },
        registeredFederally: {
          frLabel: "Votre entreprise est-elle enregistrée au fédéral?",
          label: "Is your company registered Federally?",
          inputType: "boolean",
          validator: boolean_selection_validator,
        },
        registeredProvincially: {
          frLabel: "Votre entreprise est-elle enregistrée dans une province ou un territoire?",
          label: "Is your company registered in any Provinces or Territories?",
          inputType: "boolean",
          validator: boolean_selection_validator,
        },
      }

    export const profileFormAddressDefinition: FormDefinition = {
        streetNumber: {
            label: "Street Number",
            frLabel: "Numéro civique",
            inputType: "text",
            validator: basic_text_validator,
          },
          streetName: {
            label: "Street Name",
            frLabel: "Nom de la rue",
            inputType: "text",
            validator: basic_text_validator,
          },
          unitNumber: {
            label: "Unit Number",
            frLabel: "Numéro d'appartement",
            tooltip: {
              content: "Optional Field"
            },
            frTooltip: {
              content: "Optionnel"
            },
            inputType: "text",
            validator: {
              ...basic_text_validator,
              required: false
            }
          },
          postalCode: {
            label: "Postal Code",
            frLabel: "Code postal",
            inputType: "text",
            validator: basic_text_validator,
          },
          city: {
            label: "City",
            frLabel: "Ville",
            inputType: "text",
            validator: basic_text_validator,
          },
          province: {
            label: "Province",
            frLabel: "Province",
            inputType: "text",
            validator: basic_text_validator,
          },
          country: {
            label: "Country",
            frLabel: "Pays",
            inputType: "text",
            validator: basic_text_validator,
          }
    }
